import { BehaviorSubject, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EventBusService {
  private subject: BehaviorSubject<any> = new BehaviorSubject({topic: 'default', value: undefined});

  constructor() {}

  publish<T>(topic: string, value: T): void {
    this.subject.next({ topic: topic, value: value });
  }

  subscribe<T>(topic: string, action: (arg: T) => void): Subscription {
    return this.subject
      .pipe(
        filter(x => x.topic === topic),
        map(x => x.value)
      )
      .subscribe(action);
  }
}
